var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.881,
    height: 14.881,
    viewBox: "0 0 14.881 14.881",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.379,19.819a7.441,7.441,0,1,0-7.441-7.441A7.449,7.449,0,0,0,12.379,19.819Zm-1.607-9.84A.726.726,0,0,1,11.8,8.953l2.912,2.913a.726.726,0,0,1,0,1.027L11.8,15.8a.726.726,0,1,1-1.027-1.026l2.4-2.4Z",
    transform: "translate(-4.938 -4.938)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrowIcon);
export default __webpack_public_path__ + "static/media/nextArrowIcon.d0b39d93f48cc871000c42b5b679af51.svg";
export { ForwardRef as ReactComponent };